import { useState, useEffect } from "react";
import sortBy from 'lodash/sortBy';
import words from 'lodash/words';

import { default as actions } from '../../redux/actions/amplifyActions';
import { default as useActions } from '../use-actions';
import reject from 'lodash/reject';

export const useEmployees = () => {
	const { getEmployees } = useActions(actions);
	const [employees, setEmployees] = useState([]);

	const fetchEmployees = async () => {
		try {
			const data = await getEmployees({ limit: 1000 });
			setEmployees(reject(data.value.listEmployees.items, ['status', 'DISABLED']));
      setEmployees(reject(data.value.listEmployees.items, ['jobTitle', 'Admin']));
		} catch (e) {
			console.log(e);
			setEmployees([]);
		}
	};

	useEffect(() => {
		fetchEmployees();
	}, []);

	return [{ employees }];
};

// export const useFetchEmployeesWithContacts = () => {
// 	const { getEmployeesWithContacts } = useActions(actions);

// 	return async values => {
// 		// console.log(values)
// 			const data = await getEmployeesWithContacts({ limitEmployees: 1000, limitContacts: 20000, filter: values });
// 			return data;
// 	}
// };

export const useGetEmployee = (employeeId, triggerFetch) => {
	const { getEmployee } = useActions(actions);
	const [employee, setEmployee] = useState(null);
	const fetchEmployee = async () => {
		try {
			const data = await getEmployee({ id: employeeId });
			setEmployee(data.value);
		} catch (e) {
			console.log(e);
			setEmployee(null);
		}
	};
	useEffect(() => { if (employeeId) fetchEmployee() }, [employeeId, triggerFetch]);
	return [{ employee }];
};

export const useGetEmployeeForForm = () => {
	const { getEmployee } = useActions(actions);

  return async (employeeId) => {
    const data = await getEmployee({ id: employeeId });
	  return data.value;
  }
};

export const useGetEmployeeByEmail = (userEmail) => {
	const { getEmployees } = useActions(actions);
	const [employee, setEmployee] = useState(null);
	const fetchEmployee = async () => {
		try {
			const data = await getEmployees({ limit: 1000, filter: { email: { eq: userEmail } } });
			setEmployee(data.value.listEmployees.items[0]);
		} catch (e) {
			console.log(e);
			setEmployee(null);
		}
	};
	useEffect(() => {
		fetchEmployee();
	}, []);
	return [{ employee }];
};

export const useUpdateEmployee = () => {
  const { updateEmployee } = useActions(actions);

  return async (formFields, userId) => {
    const reportFormData = JSON.stringify({formFields});
    const updatedEmployee = await updateEmployee({ input: {
      id: userId,
      reportFormData: reportFormData
    }});
  };
};

export const getInitials = string =>
    words(string)
        .map(word => word.charAt(0))
        .join('')
        .slice(0, 2);